module.exports = __webpack_public_path__ + "img/couples-089.8f061422.jpg";